var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card-code', {
    attrs: {
      "title": "Basic Radio Buttons"
    },
    scopedSlots: _vm._u([{
      key: "code",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.codeBasic) + " ")];
      },
      proxy: true
    }])
  }, [_c('b-card-text', {
    staticClass: "mb-0"
  }, [_vm._v(" You can have "), _c('code', [_vm._v("<b-form-radio>")]), _vm._v(" and "), _c('code', [_vm._v("<b-form-radio-group>")]), _vm._v(" render a browser native-styled radio input by setting the plain prop. ")]), _c('div', {
    staticClass: "demo-inline-spacing"
  }, [_c('b-form-radio', {
    attrs: {
      "plain": "",
      "name": "some-radios3",
      "value": "A"
    },
    model: {
      value: _vm.Selected,
      callback: function callback($$v) {
        _vm.Selected = $$v;
      },
      expression: "Selected"
    }
  }, [_vm._v(" Checked ")]), _c('b-form-radio', {
    attrs: {
      "plain": "",
      "name": "some-radios3",
      "value": "B"
    },
    model: {
      value: _vm.Selected,
      callback: function callback($$v) {
        _vm.Selected = $$v;
      },
      expression: "Selected"
    }
  }, [_vm._v(" Unchecked ")]), _c('b-form-radio', {
    attrs: {
      "plain": "",
      "name": "some-radios4",
      "value": "c",
      "disabled": ""
    },
    model: {
      value: _vm.Selected1,
      callback: function callback($$v) {
        _vm.Selected1 = $$v;
      },
      expression: "Selected1"
    }
  }, [_vm._v(" Checked Disabled ")]), _c('b-form-radio', {
    attrs: {
      "plain": "",
      "name": "some-radios4",
      "value": "d",
      "disabled": ""
    },
    model: {
      value: _vm.Selected1,
      callback: function callback($$v) {
        _vm.Selected1 = $$v;
      },
      expression: "Selected1"
    }
  }, [_vm._v(" Unchecked Disabled ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }